import { Node_Type } from "./../../ricos-schema/next-schema";
const listSymbolMap = {
  [Node_Type.BULLETED_LIST]: ["disc", "circle", "square"],
  [Node_Type.ORDERED_LIST]: ["decimal", "lower-latin", "lower-roman"]
};
function getListSymbol(indentation, nodeTypeName) {
  const listSymbolList = listSymbolMap[nodeTypeName];
  return listSymbolList ? listSymbolList[indentation % listSymbolList.length] : "";
}
export {
  getListSymbol
};
//# sourceMappingURL=getListSymbol.js.map
